import React from "react";
import "../../styles/Loading.css";

function Loading() {
  return (
    <div className="LoadingContainer">
      <div className="loading loading01">
        <span>L</span>
        <span>O</span>
        <span>A</span>
        <span>D</span>
        <span>I</span>
        <span>N</span>
        <span>G</span>
      </div>
    </div>
  );
}

export default Loading;
